import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnButton from "@shared/components/SnButton";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { Box } from "@mui/material";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MAS_SET_REG_014_POP_001 = forwardRef(
  ({ modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const grid1 = useRef<any>(null);

    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [grid1.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_SET_REG_014_POP_001", {});
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(rtn.formData); // 조회조건 초기값
          setColums(rtn.grid.grid1);
          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region onSearch
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_mas_set_reg_014_pop_01_01",
            params: { cd_firm: userInfo.cd_firm },
          };

          setDataSource1([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);

          if (data[0] && data[0].length > 0) {
            const selectNoEst = data[0][0];

            // 1. 그리드 데이터가 바인딩되었음을 기다림
            await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

            // 2. 첫 번째 행 선택 및 포커스 설정
            grid1.current.selectAndFocusRow(0);
          }

          grid1.current.resetUpdate();
        } catch (error) {}
      };
      fetchdatasource();
    };
    //#endregion

    //const onTabChanged = (index: string) => {
    //  setTabPage(index);
    //}

    //#region onGrid1BtnsClick
    const onGrid1BtnsClick = async (id: string) => {
      if (id == "btnAdd") {
        const newRow = {};
        grid1.current?.addRow(newRow);
      }
      if (id == "btnDelete") {
        grid1.current?.deleteSelectedRows();
      }
      if (id == "btnSave") {
        try {
          const requiredValuesCheckH = grid1.current.requiredValuesCheck();
          if (!requiredValuesCheckH) {
            return;
          }
          const changesRow = grid1.current.getChange();
          const SaveData = {
            sys_interface_config: changesRow,
          };
          if (changesRow.modifiedRowcount === 0) {
            await showDialog("alter", "변경된 내용이 없습니다.");
            return;
          }
          // 저장 API 호출
          await fnSave("SN_MAS_SET_REG_014_SAVE_01", SaveData);

          // 성공적으로 저장된 후 초기화
          grid1.current.resetUpdate();
        } catch (error: any) {}
      }
    };
    //#endregion

    //#region onBefoerAddRow
    const onBeforeAddRow = (newRow: RowData): boolean => {
      try {
        const updatedRow = {
          cd_firm: userInfo.cd_firm,
          cd_biz: userInfo.cd_biz,
        };

        Object.assign(newRow, updatedRow); // 원본 객체 수정

        return true;
      } catch (error: any) {
        return false;
      }
    };
    //#endregion

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="mb_1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            //
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="flex justify-start h-full">
          <SnAgGrid
            ref={grid1}
            //
            enableAddRow={true}
            columnConfig={columns} // 컬럼 설정 전달
            rowData={dataSource1}
            isEditable={true}
            onBeforeAddRow={onBeforeAddRow}
            title="  "
            header={
              <div className="space-x-1 flex flex-row">
                <SnButton
                  text={"행추가"}
                  onClick={() => {
                    onGrid1BtnsClick("btnAdd");
                  }}
                />
                <SnButton
                  text={"행삭제"}
                  onClick={() => {
                    onGrid1BtnsClick("btnDelete");
                  }}
                />
                <Box
                  sx={{
                    "& button": {
                      backgroundColor: "rgb(40,154,221)",
                      color: "white",
                      border: "none",
                      boxShadow: 24,
                      p: "6px 12px",
                      borderRadius: "4px",
                    },
                  }}
                >
                  <SnButton
                    text={"저장"}
                    onClick={() => {
                      onGrid1BtnsClick("btnSave");
                    }}
                  />
                </Box>
              </div>
            }
          />
        </div>
      </div>
    );
  }
  //#endregion
);

export default SN_MAS_SET_REG_014_POP_001;
